<template>
  <div class="sessions fullWidth fCol jCenter aCenter">
    <div class="closer" @click="closeSessions"></div>
    <div class="box fCol jStart aStart">
      <div class="fullWidth jStart aCenter">
        <i class="material-icons-round">privacy_tip</i>
        عنوان</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      name: 'mehdi',
    };
  },
  methods: {
    closeSessions() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
.sessions {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background-color: rgba($color: #000000, $alpha: 0.25);
  z-index: 999999999999999999999999999999;
  .closer {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    z-index: 100;
  }
  .box {
    padding: 16px;
    z-index: 2000;
    width: 80%;
    max-width: 800px;
    max-height: 75vh;
    overflow: hidden auto;
    border-radius: 16px;
    box-shadow: 0 16px 24px -12px rgba($color: #000000, $alpha: 1.0);
    background-color: white;
    h3 {
      font-size: 16px;
      color: #131313;
      padding: 0;
      margin: 0;
      i {
        color: rgba($color: #000000, $alpha: 0.75);
        margin-left: 8px;
      }
    }
  }
}
</style>
